import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('span', 'modalTitle', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalTitle.tsx